import operatorApiFetch from './apiService';

// Response shape is intentionally untyped (`Promise<any>`) — same as the
// original .js. Other operator services (brandService.ts etc.) use zod, but
// adding zod here would change runtime behavior: the error envelope on 422
// can omit `data`, which would make `apiSuccess(...).parse(...)` throw. Keep
// the conservative shape until a follow-up adds matching schemas.

const stockTransferOrderService = {
  getRecords: async (params: Record<string, unknown> = {}): Promise<any> => {
    const res = await operatorApiFetch('stock_transfer_orders/get_records', {
      method: 'POST',
      body: params,
    });
    return res.json();
  },

  get: async (id: string): Promise<any> => {
    const res = await operatorApiFetch(`stock_transfer_orders/${id}`, {
      method: 'GET',
    });
    return res.json();
  },

  create: async (data: Record<string, unknown>): Promise<any> => {
    const res = await operatorApiFetch('stock_transfer_orders', {
      method: 'POST',
      body: data,
    });
    return res.json();
  },

  update: async (id: string, data: Record<string, unknown>): Promise<any> => {
    const res = await operatorApiFetch(`stock_transfer_orders/${id}`, {
      method: 'PATCH',
      body: data,
    });
    return res.json();
  },

  cancel: async (id: string): Promise<any> => {
    const res = await operatorApiFetch(`stock_transfer_orders/${id}/cancel`, {
      method: 'POST',
    });
    return res.json();
  },

  reopen: async (id: string): Promise<any> => {
    const res = await operatorApiFetch(`stock_transfer_orders/${id}/reopen`, {
      method: 'POST',
    });
    return res.json();
  },

  // 建議調撥單號
  suggestName: async (merchantId?: string): Promise<any> => {
    const res = await operatorApiFetch('stock_transfer_orders/suggest_name', {
      method: 'GET',
      params: { merchant_id: merchantId },
    });
    return res.json();
  },
};

export { stockTransferOrderService };
export default stockTransferOrderService;
